import React from "react";
import { STATUS_LABELS } from "../lib/constants";

/**
 * StatusPill — reads its colours from CSS custom properties so it stays
 * legible in both dark and light themes (encoded in :root and .theme-light
 * in index.css).
 */
const STYLE_VARS = {
  pending: ["--st-pending-fg", "--st-pending-bg", "--st-pending-bd"],
  in_design: ["--st-in-design-fg", "--st-in-design-bg", "--st-in-design-bd"],
  in_for_planning: ["--st-planning-fg", "--st-planning-bg", "--st-planning-bd"],
  in_for_building_control: ["--st-bc-fg", "--st-bc-bg", "--st-bc-bd"],
  under_construction: ["--st-construction-fg", "--st-construction-bg", "--st-construction-bd"],
  complete: ["--st-complete-fg", "--st-complete-bg", "--st-complete-bd"],
  on_hold: ["--st-on-hold-fg", "--st-on-hold-bg", "--st-on-hold-bd"],
};

export const StatusPill = ({ status, size = "sm", className = "" }) => {
  const [fg, bg, bd] = STYLE_VARS[status] || STYLE_VARS.pending;
  const px = size === "lg" ? "px-4 py-1.5 text-xs" : "px-3 py-1 text-[10px]";
  return (
    <span
      className={`inline-flex items-center ${px} rounded-[2px] uppercase tracking-[0.16em] font-medium border ${className}`}
      style={{
        color: `var(${fg})`,
        backgroundColor: `var(${bg})`,
        borderColor: `var(${bd})`,
      }}
      data-testid={`status-pill-${status}`}
    >
      {STATUS_LABELS[status] || status}
    </span>
  );
};

export default StatusPill;
